<template>
  <div class="page ">
<div v-if="studentList.length>0" >
  <div v-for="(item,index) in studentList" :key="index" class="studentListBox">
 <studentCard :propsStudentInfo='item' />

  </div>

</div>

<van-empty
  v-else
  image-size="80"
  description="暂未绑定孩子"
/>

 <van-sticky :offset-top="'80vh'">
    <div class="button-add">
    <CustomButton @click="addStudent" text="+  学生绑定"/>
    </div>
 </van-sticky>





<van-popup v-model:show="showDialog"  :style="{ height: '100vh',width: '100%', overflow: 'hidden' }"  title="学生绑定" :show-confirm-button='false' >
  
<div class="popup_box">
<van-form @submit="onSubmit">
        <div v-if="+step == 0">
        <h5 style="margin:0 15px 20px;">您孩子就读的学校所在区域为：</h5>
        <van-field  readonly v-model="formData.areaName"  label="所在区域" placeholder="请选择学校所在区域" :rules="[{ required: true }]" @click="areaShowPicker = true;" />
        <van-sticky :offset-top="'80vh'">
        <div class="buutom">
          <CustomButton class="button-on"  text="关闭" @click="showDialog=false" type='2'/>
          <CustomButton class="button-on" text="下一步"  @click="nextStep(0)" type='1'/>
        </div>
      </van-sticky>
        </div>
        <div v-if="+step == 1" >
<div  class="popup_main">
        <h5 style="margin:0 15px 20px;">您孩子就读的学校为: {{formData.schoolName||''}}</h5>
        <van-search v-model="searchvalue" placeholder="请输入搜索关键词进行检索" />
        <div v-for="(item,i) in schoolColumns" :key="i">
<van-radio-group v-model="checked">
  <van-cell-group >
      <van-cell :title="item.text"  is-link  @click="onConfirmSchool(item)">
        <template #right-icon>
          <van-radio :name="item.value" />
        </template>
    </van-cell>
  </van-cell-group>
</van-radio-group>
        </div>
</div>

    <van-sticky :offset-top="'80vh'" >
        <div class="buutom">
          <CustomButton  class="button-on"  text="上一步" @click="upStep(1)" type='2'/>
          <CustomButton class="button-on" text="下一步"  @click="nextStep(1)" type='1'/>
        </div>
      </van-sticky>
        
        </div>

        <div v-if="+step == 2">
     <h5 style="margin:0 15px 20px;">学生信息</h5>
         <van-field label-width='110' v-model="formData.studentName" type="text" name="姓名" label="姓名" placeholder="请输入姓名"
          :rules="[{ required: true }]" />
            <van-field label-width='110'  v-model="formData.idNumber" type="text" name="身份证号" label="身份证号" placeholder="请输入身份证号"
          :rules="[{ required: true }]" />


          <van-number-keyboard
          v-model="formData.idNumber"
          :show="showidNumber"
          extra-key="X"
          close-button-text="完成"
          @blur="showidNumber = false"
        />
        <!-- <van-field label-width='110' v-model="formData.inSchooleYear"  type="number" :maxlength='4' name="入学年份" label="入学年份" placeholder="请输入入学年份"
          :rules="[{ required: true }]" /> -->
<!-- ==-------------------------- -->




        <!-- <h5 style="margin:16px 15px;">验证信息</h5> -->
      
        <!-- <van-field label-width='110' v-model="formData.adminTeacherName" maxlength='1' type="text" name="班主任姓氏" label="班主任姓氏" placeholder="请输入班主任姓氏"
          :rules="[{ required: true }]" />
          
        <van-field label-width='110' v-model="formData.adminTeacherSex" type="text" name="班主任性别" label="班主任性别" placeholder="请输入班主任性别"
          :rules="[{ required: true }]" > -->
    <!-- <template #input>
       <van-radio-group v-model="formData.adminTeacherSex" direction="horizontal">
        <van-radio name="男">男</van-radio>
        <van-radio name="女">女</van-radio>
      </van-radio-group>
    </template>
  </van-field> -->
        <!-- <van-field label-width='110' v-model="formData.sportTeacherName" maxlength='1' type="text" name="体育老师姓氏" label="体育老师姓氏" placeholder="请输入体育老师姓氏"
          :rules="[{ required: true }]" />
        <van-field label-width='110' v-model="formData.sportTeacherSex" type="text" name="体育老师性别" label="体育老师性别" placeholder="请输入体育老师性别"
          :rules="[{ required: true }]" >
    <template #input>
       <van-radio-group v-model="formData.sportTeacherSex" direction="horizontal">
        <van-radio name="男">男</van-radio>
        <van-radio name="女">女</van-radio>
      </van-radio-group>
    </template>
  </van-field> -->
        <van-sticky :offset-top="'80vh'">
        <div class="buutom">
          <CustomButton  class="button-on"  text="上一步" @click="upStep(2)" type='2'/>
          <CustomButton  class="button-on" text="确认" native-type="submit" type='1'/>
          <!-- <CustomButton class="button-on"  text="下一步"  @click="nextStep(2)" type='1'/> -->
        </div>
      </van-sticky>
        </div>
        <div v-if="+step == 3">
        <h5 style="margin:0 15px 20px;">学生信息验证</h5>
         <van-field label-width='110' v-model="formData.studentName" type="text" name="姓名" label="姓名" placeholder="请输入姓名"
          :rules="[{ required: true }]" />
            <van-field label-width='110'  v-model="formData.idNumber" type="text" name="身份证号" label="身份证号" placeholder="请输入身份证号"
          :rules="[{ required: true }]" />
          <van-number-keyboard
          v-model="formData.idNumber"
          :show="showidNumber"
          extra-key="X"
          close-button-text="完成"
          @blur="showidNumber = false"
        />
        <!-- <van-field label-width='110' v-model="formData.inSchooleYear"  type="number" :maxlength='4' name="入学年份" label="入学年份" placeholder="请输入入学年份"
          :rules="[{ required: true }]" /> -->
        <van-sticky :offset-top="'80vh'">
     <div class="buutom">
          <CustomButton  class="button-on" text="上一步" @click="upStep(3)" type='2'/>
          <CustomButton  class="button-on" text="确认" native-type="submit" type='1'/>
        </div>
      </van-sticky>
        </div>

   
    

 

  <!-- <div class="buutom">
    <CustomButton  text="返回" @click="showDialog=false" type='2'/>
    <CustomButton  text="确认" native-type="submit" type='1'/>
  </div> -->
      </van-form>
</div>
</van-popup>

   <van-popup v-model="areaShowPicker" round position="bottom" :style="{ height: '55%' }">
        <van-area title="省市区选择" :area-list="areaList"  @cancel="areaShowPicker = false" value="320105"  @confirm="onConfirmArea"/>
    </van-popup>


   <van-popup v-model="schoolShowPicker" round position="bottom" :style="{ height: '55%' }">
      <van-search v-model="searchvalue" placeholder="请输入搜索关键词进行检索" />
      <van-picker :columns="schoolColumns" :default-index="defaultIndex" show-toolbar @cancel="schoolShowPicker = false"
        @confirm="onConfirmSchool" />
    </van-popup>
    <!-- <van-button round block type="info" class="button-add" @click="addStudent">+  绑定孩子</van-button> -->


  </div>
</template>

<script>
import { Notify } from "vant";
import CustomButton from "@/components/CustomButton.vue";

import { getSchoolList} from "@/api/common";
import { getChildInfoList,bindStudentInfo} from "@/api/studentBind.js";
    import wx from 'weixin-js-sdk'
import { loginByOpenId} from "@/api/bind"
import { getSchoolInfoByCityCode} from "@/api/common"

import { setLocal, getLocal } from '@/utils/cookie'

import studentCard from "@/components/studentCard.vue";
import { areaList } from '@vant/area-data';

export default {
  name: "studentBind",
  components: {CustomButton,studentCard},
  data() {
    return {
      step:0,
      snCode: "",
      studentName: "",
      openId: "",
      areaList:areaList,
      formData:{
        areaName:'',
        schoolName:'',
        adminTeacherName:'',
        sportTeacherName:'',
        adminTeacherSex:'男',
        sportTeacherSex:'男'
      },
      active:'0',
      checked:'',
      showDialog:false,
      schoolShowPicker:false,
      areaShowPicker:false,
      showidNumber:false,
      areaPickerList:[],
      searchvalue:'',
      schoolColumns:[],
      columnsAll:[],
      defaultIndex:'',
      studentList:[],
      statusMap:['待审核','通过','已驳回']
    };
  },
   watch: {
    searchvalue(val) {
      console.log(val);
      let search = val;
      this.schoolColumns = this.columnsAll.filter(function (product) {
        console.log("过滤", product);
        let searchField = { text: product.text, value: product.value };
        return Object.keys(searchField).some(function (key) {
          console.log("key值", key);
          return String(product[key]).toLowerCase().indexOf(search) > -1;
        });
      });
    },
  },
  created() {
  
  },
  mounted () {
    // this.getSchoolList()
    this.getChildInfoList()
  },
  methods: {
onConfirmArea(val){
console.log(val);
this.areaPickerList = val
this.formData.areaName = val[0].name + '-'+val[1].name + '-'+val[2].name
  this.formData.schoolName = '';
  this.formData.schoolCode = '';
  this.checked = ''

getSchoolInfoByCityCode({
  code:val[2].code
}).then((res)=>{
console.log(res);
   this.columnsAll = res.data.data.map((item) => {
        return { text: item.cnName, value: item.schCode };
    });
   this.schoolColumns = res.data.data.map((item) => {
        return { text: item.cnName, value: item.schCode };
   });

   if (this.schoolColumns.length>0) {
  this.checked = this.schoolColumns[0].value
  this.formData.schoolName = this.schoolColumns[0].text
  this.formData.schoolCode = this.schoolColumns[0].value
   }
console.log(res);

// 下一步
        this.step = 0 + 1
})
this.areaShowPicker =false

},



nextStep(val){
if (val == 0&&this.formData.areaName=='') {
  this.$notify({ type: "warning", message: '请选择学校所在区域！' });
  return
}
if (val == 1&&this.formData.schoolName=='') {
  this.$notify({ type: "warning", message: '请填写学校！' });
  return
}else if (val==2) {

  if (this.formData.adminTeacherName==''||this.formData.adminTeacherSex==''||
  this.formData.sportTeacherName==''||this.formData.sportTeacherSex=='') {
  this.$notify({ type: "warning", message: '请填写全部信息！' });
    return
  }
}
this.step = val + 1

},
upStep(val){
this.step = val -1
},


    getChildInfoList(){
getChildInfoList({
  status:'-1'
}).then(res=>{
  this.studentList = res.data.data||[]
  this.studentList?.forEach(el=>{
    if (el.sex=='男') {
      this.$set(el,'sexImg',require("@/assets/image/男.png") )
    }else if(el.sex=='女'){
      this.$set(el,'sexImg',require("@/assets/image/女.png") )
    }
  })
console.log(res);
})
    },
    getSchoolList() {
      getSchoolList().then((res) => {
        const body = res?.data?.body || res?.data?.data || res?.data || [];
        if (Array.isArray(body)) {
          this.columnsAll = body.map((item) => ({ text: item.name, value: item.code }));
          this.schoolColumns = body.map((item) => ({ text: item.name, value: item.code }));
        } else {
          this.columnsAll = [];
          this.schoolColumns = [];
        }
      }).catch(() => {
        this.columnsAll = [];
        this.schoolColumns = [];
      });
    },
    addStudent(){

    loginByOpenId({openId:getLocal('openId')}).then(res=>{
              console.log(res);
              setLocal("userInfo", JSON.stringify(res.data.body));
              setLocal("Authorization", res.data.body.token);

      this.formData = {
          areaName:'',
          schoolName:'',
        adminTeacherName:'',
        sportTeacherName:'',
        adminTeacherSex:'男',
        sportTeacherSex:'男',
      }
      this.showDialog = true
              })


      //   this.formData = {
      //     areaName:'',
      //     schoolName:'',
      //   adminTeacherName:'',
      //   sportTeacherName:'',
      //   adminTeacherSex:'男',
      //   sportTeacherSex:'男',
      // }
      // this.showDialog = true
        // loginByOpenId({openId:getLocal('openId')}).then(res=>{
        //       console.log(res);
        //       setLocal("userInfo", JSON.stringify(res.data.body));
        //       setLocal("Authorization", res.data.body.token);

    
        //       })



    },
    onSubmit(){
console.log(this.formData);
let data = {...this.formData}
bindStudentInfo(data).then(res=>{
    this.$notify({ type: "success", message: '绑定成功' });
    this.getChildInfoList()
    this.formData = {
        areaName:'',
        schoolName:'',
        adminTeacherName:'',
        sportTeacherName:'',
        adminTeacherSex:'男',
        sportTeacherSex:'男',
    }
    this.step = 0 
    this.showDialog = false;
  // wx.closeWindow()
})
    },
    // 选择学校
       onConfirmSchool(val) {
        this.formData.schoolName = val.text;
        this.formData.schoolCode = val.value;
        this.checked = val.value
      //  this.$dialog
      //   .alert({
      //     message: `是否确认就读学校为：${val.text}`,
      //     showCancelButton: true
      //   })
      //   .then(() => {
      //   this.formData.schoolName = val.text;
      //   this.formData.schoolCode = val.value;
      //   // 下一步
      //   this.step = 1 + 1

      //   })
        // .catch(() => {
        //   // on cancel
        // })
       
        // this.schoolShowPicker = false;
    },
    onRemove(){
        this.$dialog
        .alert({
          message: '是否确认解除绑定?',
          showCancelButton: true
        })
        .then(() => {
           
        })
        .catch(() => {
          // on cancel
        })
    },

  },
};
</script>


<style scoped lang="less">

.page{
// height: 100vh; 
background: #FFF;
height: 100%;
padding: 10px 0;
  }

  .studentListBox{
    margin: 10px 0;
  }
.dialogBox{
  height: 100vh;
  width: 100%;
  background-color: #fafafa;
  padding-top: 20px;
  overflow: scroll;
  .bottombox{
    position: absolute;
    top: 0;
    left: 0;
  }

  ::v-deep .van-cell{
    line-height: 28px;
  }
}

.popup_box {
  height: 100vh;
  background-color: #fafafa;
  overflow: hidden;
  position: relative;
  padding-top: 20px;

  .popup_bottom {
    width: 100%;
    height: 1.31rem;
    position: absolute;
    bottom: 0;
    display: flex;
  }
  .popup_main {
    background-color: #fafafa;
    height: 80vh;
    overflow-y: scroll;
  }
}


.buutom {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  height: 60px;
  .button-on{
    width: 48%;
}
}
  .button-add{
    width: 80%;
    margin: 0 auto;
    margin-top: 50px;
}

</style>
